import {
  UPDATE_TOKEN,
  UPDATE_USER_INFO,
  UPDATE_PERMISSIONS
} from './mutation-types'
import { getToken, getUserInfo } from 'index/api'
export default {
  [UPDATE_TOKEN]: ({ commit }) => getToken().then(token => {
    commit(UPDATE_TOKEN, token)
    return token
  }),
  /**
   * 更新用户信息
   */
  [UPDATE_USER_INFO]: ({ commit }) => getUserInfo().then(data => {
    const { user, permissions } = data
    commit(UPDATE_USER_INFO, user)
    commit(UPDATE_PERMISSIONS, permissions)
    return data
  })
}
